import { __ } from '@wordpress/i18n';
import { qs } from '../dom-helpers';
import AJAX from './class.AJAX';
import Abstract from './class.Abstract';
import FormValidator from './class.FormValidator';

class ForgotPassword {
  constructor() {
    if (!qs('.page-template-forgot-password-template')) return;

    this.firstStepForm = qs('.account__form--forgot-password-step-1');
    this.secondStepForm = qs('.account__form--forgot-password-step-2');
    this.formStatus = qs('form .alert');
    this.submitButton = qs('form button[type="submit"]');

    this._run();
  }

  _run() {
    if (this.firstStepForm) {
      this._handleFirstFormSubmit();
    }

    if (this.secondStepForm) {
      this._handleSecondFormSubmit();
    }
  }

  _handleFirstFormSubmit() {
    const _this = this;

    this.firstStepForm.addEventListener('submit', (e) => {
      e.preventDefault();

      if (!this._isFirstFormValid()) return;

      const data = new FormData(this.firstStepForm);

      AJAX.post({
        action: 'mst_somi_forgot_password_step_1',
        data: Abstract.formDataToObject(data),
        beforeSend() {
          _this.submitButton.disabled = true;
        },
        complete() {
          _this.submitButton.disabled = false;
        },
        success(response) {
          const level = response.success ? 'success' : 'error';
          _this._writeStatus(level, response.data.message);

          if (response.success) {
            _this.firstStepForm.reset();
          }
        },
      });
    });
  }

  _handleSecondFormSubmit() {
    const _this = this;

    this.secondStepForm.addEventListener('submit', (e) => {
      e.preventDefault();

      if (!this._isSecondFormValid()) return;

      const data = new FormData(this.secondStepForm);

      AJAX.post({
        action: 'mst_somi_forgot_password_step_2',
        data: Abstract.formDataToObject(data),
        beforeSend() {
          _this.submitButton.disabled = true;
        },
        complete() {
          _this.submitButton.disabled = false;
        },
        success(response) {
          const level = response.success ? 'success' : 'error';
          _this._writeStatus(level, response.data.message);

          if (response.success) {
            _this.secondStepForm.reset();
          }
        },
      });
    });
  }

  _isFirstFormValid() {
    return new FormValidator().isValid(this.firstStepForm, {
      billing_ssn: {
        presence: {
          message: __('^SSN field can\'t be empty', 'mst_somi_js'),
        },
        _ssn: {
          message: __('^Incorrect SSN format', 'mst_somi_js'),
        },
      },
    });
  }

  _isSecondFormValid() {
    const passwordField = qs('[name="new_password"]', this.secondStepForm);
    const passwordConfirmationField = qs('[name="password_confirmation"]', this.secondStepForm);

    return new FormValidator().isValid(this.secondStepForm, {
      new_password: {
        presence: {
          message: __('^New password field can\'t be empty', 'mst_somi_js'),
        },
        _equalPasswords: {
          firstPassword: passwordField.value.trim(),
          secondPassword: passwordConfirmationField.value.trim(),
          message: __('^Passwords must be equal', 'mst_somi_js'),
        },
      },
      password_confirmation: {
        presence: {
          message: __('^Password confirmation field can\'t be empty', 'mst_somi_js'),
        },
        _equalPasswords: {
          firstPassword: passwordField.value.trim(),
          secondPassword: passwordConfirmationField.value.trim(),
          message: __('^Passwords must be equal', 'mst_somi_js'),
        },
      },
    });
  }

  _writeStatus(level, status) {
    Abstract.fadeIn(this.formStatus);

    this.formStatus.classList.add(level);
    this.formStatus.innerText = status;

    setTimeout(() => {
      Abstract.fadeOut(this.formStatus);

      this.formStatus.classList.remove(level);
      this.formStatus.innerText = '';
    }, 8000);
  }
}

export default ForgotPassword;
